import TRadio from './radio.vue'
import TRadioGroup from './radio-group.vue'

TRadio.Group = TRadioGroup
export default TRadio



// WEBPACK FOOTER //
// ./src/components/radio/index.js